define("command-palette/utils/search-commands-query", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.parseQuery = parseQuery;
  0; //eaimeta@70e063a35619d71feaimeta@70e063a35619d71f
  function safePush(obj, key, value) {
    if (obj[key]?.length) {
      obj[key].push(value);
      return;
    }
    obj[key] = [value];
  }
  function getQueryParts(query) {
    const parts = [];
    let isInQuote = false;
    let currentPart = '';
    query.split('').forEach(char => {
      if (char === ' ') {
        if (!isInQuote) {
          parts.push(currentPart);
          currentPart = '';
          return;
        }
      }
      if (char === '"') {
        isInQuote = !isInQuote;
      }
      currentPart += char;
    });
    currentPart && parts.push(currentPart);
    return parts;
  }
  function parseQuery(query) {
    const tokens = {
      mentions: [],
      tags: [],
      text: []
    };
    const parts = getQueryParts(query);
    parts.forEach((part, partIdx) => {
      const isLastPart = partIdx === parts.length - 1;
      if (part.startsWith('@')) {
        safePush(tokens, 'mentions', part.replace('@', ''));
      } else if (part.startsWith('#')) {
        safePush(tokens, 'tags', part.replace('#', ''));
      } else if (part.startsWith('"') && (part.endsWith('"') || isLastPart)) {
        safePush(tokens, 'text', part.replace(/"/g, ''));
      } else if (part.includes(':')) {
        const [key, value] = part.split(':');
        safePush(tokens, key, value);
      }
    });
    return {
      raw: query,
      normalized: normalizeQuery(query),
      parts,
      tokens
    };
  }
  function normalizeQuery(query) {
    return query.toLowerCase().trim();
  }
});